module.exports = __webpack_public_path__ + "img/cooperation_title.f9b068d9.png";